













































































import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import Vue from 'vue';

import FinalConfirmMixins from './mixins';
import _ from 'lodash';

@Component
export default class FinalConfirmPage extends mixins(Vue, FinalConfirmMixins) {
  public isTop: boolean = true;
  public isBottom: boolean = true;

  onLoaded() {
    this.$store.commit(
      'Header',
      this.$t('vs.final.header.title.' + (this.ConfirmData.length > 1 ? 'multi' : 'single')) as string,
    );
    this.onScroll();
  }

  onScroll = _.debounce(this._onScroll, 300);

  _onScroll(e?: Event) {
    var el = this.$refs.scrollContent as HTMLElement;
    if (el) {
      let top = el.scrollTop;
      let bottom = el.scrollHeight - el.scrollTop - el.offsetHeight;

      this.isTop = top < 2;
      this.isBottom = bottom < 2;
    }
  }

  scrollUp() {
    var el = this.$refs.scrollContent as HTMLElement;
    if (el) {
      el.scrollBy({
        top: -el.offsetHeight * 0.9,
        left: 0,
        behavior: 'smooth',
      });
    }
  }

  scrollDown() {
    var el = this.$refs.scrollContent as HTMLElement;
    if (el) {
      if (el) {
        el.scrollBy({
          top: el.offsetHeight * 0.9,
          left: 0,
          behavior: 'smooth',
        });
      }
    }
  }
}
